<template>
  <div :class="screenClass">
    <!-- PRODUCT PRIMARY -->
    <div v-if="changeProductDialogSelectedPrimary">
      <div v-if="changeProductDialogPage == 0">
        <div
          :class="
            !$vuetify.breakpoint.smAndDown
              ? 'pt-3 pl-7 product-change-dialog'
              : 'pt-3'
          "
        >
          <div v-if="dialogLoading" class="loading-layout">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>

          <div v-else>
            <v-row>
              <v-col
                :cols="!$vuetify.breakpoint.smAndDown ? 7 : 12"
                :class="
                  !$vuetify.breakpoint.smAndDown ? 'justify-content-center' : ''
                "
              >
                <v-row class="align-center">
                  <v-col
                    v-on:click="closeChangeProductDialog()"
                    :cols="!$vuetify.breakpoint.smAndDown ? 1 : 2"
                    :class="!$vuetify.breakpoint.smAndDown ? '' : 'mr-0 pr-0'"
                  >
                    <v-btn elevation="2" icon
                      ><v-icon>mdi-chevron-left</v-icon></v-btn
                    >
                  </v-col>
                  <v-col
                    :cols="!$vuetify.breakpoint.smAndDown ? 11 : 10"
                    :class="!$vuetify.breakpoint.smAndDown ? '' : 'ml-0 pl-0'"
                  >
                    <v-card-title>Min strømavtale</v-card-title>
                    <v-card-subtitle class="force-align-left">{{
                      getAddressTitle(
                        changeProductDialogSelectedContract.Address || {}
                      )
                    }}</v-card-subtitle>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="pt-0 mt-2">
              <v-col
                :cols="!$vuetify.breakpoint.smAndDown ? 11 : 12"
                :class="
                  !$vuetify.breakpoint.smAndDown
                    ? 'justify-content-center pt-0 mt-0'
                    : 'pt-0 mt-0'
                "
              >
                <v-row class="align-center current-contract">
                  <v-col>
                    <v-card class="pt-3 pl-3 pb-3">
                      <v-row>
                        <v-col :cols="!$vuetify.breakpoint.smAndDown ? 1 : 2">
                          <template
                            v-if="
                              changeProductDialogSelectedProduct.PrimaryProduct
                            "
                          >
                            <v-avatar color="primary" size="48">
                              <v-icon class="white--text"
                                >mdi-lightning-bolt</v-icon
                              >
                            </v-avatar>
                          </template>
                          <template v-else>
                            <v-avatar size="48" class="primary-color-border">
                              <v-icon color="primary">mdi-power-plug</v-icon>
                            </v-avatar>
                          </template>
                        </v-col>
                        <v-col
                          :cols="!$vuetify.breakpoint.smAndDown ? 11 : 10"
                          class="pl-1"
                        >
                          <v-card-title class="pt-0 mt-0 pb-3 mb-0">{{
                            changeProductDialogSelectedProduct.ProductName
                          }}</v-card-title>
                        </v-col>
                      </v-row>
                      <template
                        v-if="changeProductDialogSelectedProduct.PrimaryProduct"
                      >
                        <template
                          v-if="
                            changeProductDialogSelectedContractUpcommingPrimary.StartDate
                          "
                        >
                          <v-row>
                            <v-col cols="10">
                              <v-alert
                                text
                                dense
                                color="teal"
                                icon="mdi-clock-fast"
                                border="left"
                                class="mb-0"
                              >
                                {{
                                  getNorwayFormattedDate(
                                    changeProductDialogSelectedContractUpcommingPrimary.StartDate
                                  ) +
                                  ' endres avtalen til ' +
                                  changeProductDialogSelectedContractUpcommingPrimary.ProductName
                                }}
                              </v-alert>
                            </v-col>
                          </v-row>
                        </template>
                      </template>
                      <template v-else>
                        <template
                          v-if="
                            changeProductDialogSelectedContractUpcommingSecondary.StartDate
                          "
                        >
                          <v-row>
                            <v-col cols="10">
                              <v-alert
                                text
                                dense
                                color="teal"
                                icon="mdi-clock-fast"
                                border="left"
                                class="mb-0"
                              >
                                {{
                                  getNorwayFormattedDate(
                                    changeProductDialogSelectedContractUpcommingSecondary.StartDate
                                  ) +
                                  ' endres avtalen til ' +
                                  changeProductDialogSelectedContractUpcommingSecondary.ProductName
                                }}
                              </v-alert>
                            </v-col>
                          </v-row>
                        </template>
                      </template>
                      <v-row class="pb-3">
                        <v-col>
                          <v-btn
                            color="primary"
                            outlined
                            rounded
                            class="common-btn primary-color"
                            v-on:click="openChangeProductDialog(1)"
                          >
                            Bytt strømavtale
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
                <template v-if="changeProductDialogWarning">
                  <v-alert text dense color="teal" border="left">
                    Du har bindingstid på din eksisterende strømavtale.
                    {{
                      changeProductDialogSelectedContract &&
                      changeProductDialogSelectedContract.EndDate
                        ? ' Denne avtalen går ut ' +
                          getNorwayFormattedDate(
                            changeProductDialogSelectedContract.EndDate
                          ) +
                          '.'
                        : ''
                    }}
                    Du kan bestille ny avtale 20 dager før utløpsdato. Ta
                    kontakt med kundeservice om du har spørsmål angående dette.
                  </v-alert>
                </template>
              </v-col>
            </v-row>
          </div>
          <v-snackbar v-model="dialogSnackbar">
            {{ dialogSnackbarText }}

            <template v-slot:action="{ attrs }">
              <v-btn
                color="pink"
                text
                v-bind="attrs"
                v-on:click="dialogSnackbar = false"
              >
                Lukke
              </v-btn>
            </template>
          </v-snackbar>
        </div>
      </div>
      <div v-if="changeProductDialogPage == 1">
        <div
          :class="
            !$vuetify.breakpoint.smAndDown
              ? 'pt-3 pl-7 product-change-dialog'
              : 'pt-3'
          "
        >
          <div v-if="dialogLoading" class="loading-layout">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>

          <div v-else>
            <v-row>
              <v-col
                :cols="!$vuetify.breakpoint.smAndDown ? 7 : 12"
                :class="
                  !$vuetify.breakpoint.smAndDown ? 'justify-content-center' : ''
                "
              >
                <v-row class="align-center">
                  <v-col
                    v-on:click="closeChangeProductDialog()"
                    :cols="!$vuetify.breakpoint.smAndDown ? 1 : 2"
                    :class="!$vuetify.breakpoint.smAndDown ? '' : 'mr-0 pr-0'"
                  >
                    <v-btn elevation="2" icon
                      ><v-icon>mdi-chevron-left</v-icon></v-btn
                    >
                  </v-col>
                  <v-col
                    :cols="!$vuetify.breakpoint.smAndDown ? 11 : 10"
                    :class="!$vuetify.breakpoint.smAndDown ? '' : 'ml-0 pl-0'"
                  >
                    <v-card-title>Velg ny strømavtale</v-card-title>
                    <v-card-subtitle class="force-align-left">{{
                      getAddressTitle(
                        changeProductDialogSelectedContract.Address || {}
                      )
                    }}</v-card-subtitle>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="pt-0 mt-2">
              <v-col
                :cols="!$vuetify.breakpoint.smAndDown ? 11 : 12"
                :class="
                  !$vuetify.breakpoint.smAndDown
                    ? 'justify-content-center pt-0 mt-0'
                    : 'pt-0 mt-0'
                "
              >
                <v-row class="align-center current-contract">
                  <v-col>
                    <v-card class="pt-3 pl-3 pb-3 mb-5">
                      <v-row>
                        <v-col :cols="!$vuetify.breakpoint.smAndDown ? 1 : 2">
                          <v-avatar
                            color="primary"
                            size="48"
                            style="opacity: 60%"
                          >
                            <template
                              v-if="
                                changeProductDialogSelectedProduct.PrimaryProduct
                              "
                            >
                              <v-avatar
                                color="primary"
                                size="48"
                                style="opacity: 60%"
                              >
                                <v-icon class="white--text"
                                  >mdi-lightning-bolt</v-icon
                                >
                              </v-avatar>
                            </template>
                            <template v-else>
                              <v-avatar size="48" class="primary-color-border">
                                <v-icon color="primary">mdi-power-plug</v-icon>
                              </v-avatar>
                            </template>
                          </v-avatar>
                        </v-col>
                        <v-col
                          :cols="!$vuetify.breakpoint.smAndDown ? 11 : 10"
                          class="pl-1"
                        >
                          <v-card-title
                            class="pt-0 mt-0 pb-3 mb-0"
                            style="opacity: 60%"
                            >{{
                              changeProductDialogSelectedProduct.ProductName
                            }}</v-card-title
                          >
                          <v-card-subtitle
                            class="force-align-left"
                            style="opacity: 60%"
                            >{{
                              changeProductDialogSelectedProduct.Description
                            }}</v-card-subtitle
                          >
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <span class="primary-color">Gjeldende avtale</span>
                        </v-col>
                      </v-row>
                    </v-card>
                    <template
                      v-if="changeProductDialogSelectedProduct.PrimaryProduct"
                    >
                      <v-card
                        v-for="(item, key) in allPrimaryProducts.filter(
                          (product) =>
                            product.id !=
                              changeProductDialogSelectedProduct.ProductId &&
                            hasTag(product, 'minside') &&
                            product.visible === true
                        )"
                        :key="key"
                        class="pt-3 pl-3 pb-3 mb-5"
                      >
                        <v-row>
                          <v-col
                            :cols="!$vuetify.breakpoint.smAndDown ? 1 : 2"
                            class="mb-0 pb-0"
                          >
                            <v-avatar color="primary" size="48">
                              <v-icon class="white--text"
                                >mdi-lightning-bolt</v-icon
                              >
                            </v-avatar>
                          </v-col>
                          <v-col
                            :cols="!$vuetify.breakpoint.smAndDown ? 11 : 10"
                            class="pl-1 mb-0 pb-0"
                          >
                            <v-card-title class="pt-0 mt-0 pb-3 mb-0">{{
                              item.name
                            }}</v-card-title>
                            <v-card-subtitle class="force-align-left">{{
                              item.description
                            }}</v-card-subtitle>
                          </v-col>
                        </v-row>
                        <v-row class="pb-3">
                          <v-col>
                            <v-btn
                              color="primary"
                              outlined
                              rounded
                              class="common-btn primary-color px6"
                              v-on:click="openChangeProductDialog(2, item)"
                            >
                              Endre til denne avtalen
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-card>
                    </template>
                    <template v-else>
                      <v-card
                        v-for="(item, key) in allSecondaryProducts.filter(
                          (product) =>
                            product.id !=
                              changeProductDialogSelectedProduct.ProductId &&
                            hasTag(product, 'minside') &&
                            product.visible === true
                        )"
                        :key="key"
                        class="pt-3 pl-3 pb-3 mb-5"
                      >
                        <v-row>
                          <v-col
                            :cols="!$vuetify.breakpoint.smAndDown ? 1 : 2"
                            class="mb-0 pb-0"
                          >
                            <v-avatar size="48" class="primary-color-border">
                              <v-icon color="primary">mdi-power-plug</v-icon>
                            </v-avatar>
                          </v-col>
                          <v-col
                            :cols="!$vuetify.breakpoint.smAndDown ? 11 : 10"
                            class="pl-1 mb-0 pb-0"
                          >
                            <v-card-title class="pt-0 mt-0 pb-3 mb-0">{{
                              item.name
                            }}</v-card-title>
                            <v-card-subtitle class="force-align-left">{{
                              item.description
                            }}</v-card-subtitle>
                          </v-col>
                        </v-row>
                        <v-row class="pb-3 pt-0 mt-0">
                          <v-col>
                            <div
                              class="common-btn primary-color"
                              v-on:click="openChangeProductDialog(2, item)"
                            >
                              Endre til denne avtalen
                            </div>
                          </v-col>
                        </v-row>
                      </v-card>
                    </template>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
          <v-snackbar v-model="dialogSnackbar">
            {{ dialogSnackbarText }}

            <template v-slot:action="{ attrs }">
              <v-btn
                color="pink"
                text
                v-bind="attrs"
                v-on:click="dialogSnackbar = false"
              >
                Lukke
              </v-btn>
            </template>
          </v-snackbar>
        </div>
      </div>
      <div v-if="changeProductDialogPage == 2">
        <div
          :class="
            !$vuetify.breakpoint.smAndDown
              ? 'pt-3 pl-7 product-change-dialog'
              : 'pt-3'
          "
        >
          <div v-if="dialogLoading" class="loading-layout">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>

          <div v-else>
            <v-row>
              <v-col
                :cols="!$vuetify.breakpoint.smAndDown ? 7 : 12"
                :class="
                  !$vuetify.breakpoint.smAndDown ? 'justify-content-center' : ''
                "
              >
                <v-row class="align-center">
                  <v-col
                    v-on:click="closeChangeProductDialog()"
                    :cols="!$vuetify.breakpoint.smAndDown ? 1 : 2"
                    :class="!$vuetify.breakpoint.smAndDown ? '' : 'mr-0 pr-0'"
                  >
                    <v-btn elevation="2" icon
                      ><v-icon>mdi-chevron-left</v-icon></v-btn
                    >
                  </v-col>
                  <v-col
                    :cols="!$vuetify.breakpoint.smAndDown ? 11 : 10"
                    :class="!$vuetify.breakpoint.smAndDown ? '' : 'ml-0 pl-0'"
                  >
                    <v-card-title>Bekreft ny strømavtale</v-card-title>
                    <v-card-subtitle class="force-align-left">{{
                      getAddressTitle(
                        changeProductDialogSelectedContract.Address || {}
                      )
                    }}</v-card-subtitle>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="pt-0 mt-2">
              <v-col
                :cols="!$vuetify.breakpoint.smAndDown ? 11 : 12"
                :class="
                  !$vuetify.breakpoint.smAndDown
                    ? 'justify-content-center pt-0 mt-0'
                    : 'pt-0 mt-0'
                "
              >
                <v-row class="align-center current-contract mb-0 pb-0">
                  <v-col>
                    <v-card class="pt-3 pl-3 pb-3">
                      <v-row>
                        <v-col
                          :cols="!$vuetify.breakpoint.smAndDown ? 1 : 2"
                          class="pb-0 mb-0"
                        >
                          <template
                            v-if="changeProductDialogNewProduct.primaryProduct"
                          >
                            <v-avatar color="primary" size="48">
                              <v-icon class="white--text"
                                >mdi-lightning-bolt</v-icon
                              >
                            </v-avatar>
                          </template>
                          <template v-else>
                            <v-avatar color="primary" size="48">
                              <v-icon class="white--text"
                                >mdi-power-plug</v-icon
                              >
                            </v-avatar>
                          </template>
                        </v-col>
                        <v-col
                          :cols="!$vuetify.breakpoint.smAndDown ? 11 : 10"
                          class="pl-1 pb-0 mb-0"
                        >
                          <v-card-title class="pt-0 mt-0 pb-3 mb-0">{{
                            changeProductDialogNewProduct.name
                          }}</v-card-title>
                          <v-card-subtitle class="force-align-left">{{
                            changeProductDialogNewProduct.description
                          }}</v-card-subtitle>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <div class="d-flex flex-direction-row">
                            <div>
                              <v-icon color="primary"
                                >mdi-clock-time-four</v-icon
                              >
                            </div>
                            <div class="ml-3">
                              <span
                                >Avtalen blir aktivert
                                {{ getActivationDate() }}</span
                              >
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="mt-0 pt-0">
                <div class="d-flex flex-direction-row">
                  <v-checkbox
                    v-model="changeProductDialogCheck"
                    hide-details
                    class="mt-0 pt-0"
                  ></v-checkbox>
                  <template v-if="(tenantData() || {}).withdrawal_rights">
                    <span
                      :class="!$vuetify.breakpoint.smAndDown ? '' : 'text-left'"
                      >Jeg godtar
                      <a
                        :href="(tenantData() || {}).agreement_terms"
                        target="_blank"
                        >avtalevilkårene</a
                      >
                      og er kjent med
                      <a
                        :href="(tenantData() || {}).withdrawal_rights"
                        target="_blank"
                        >angreretten</a
                      ></span
                    >
                  </template>
                  <template v-else>
                    <span
                      :class="!$vuetify.breakpoint.smAndDown ? '' : 'text-left'"
                      >Jeg godtar
                      <a
                        :href="(tenantData() || {}).agreement_terms"
                        target="_blank"
                        >avtalevilkårene</a
                      ></span
                    >
                  </template>
                </div>
              </v-col>
            </v-row>
            <v-row class="mb-3">
              <v-col class="force-align-left ml-0 pl-0">
                <v-btn
                  color="primary"
                  class="ma-2 white--text"
                  v-on:click="setNewProduct()"
                >
                  BYTT PRODUKT
                </v-btn>
                <v-btn class="ma-2" v-on:click="closeChangeProductDialog()">
                  AVBRYT
                </v-btn>
              </v-col>
            </v-row>
          </div>
          <v-snackbar v-model="dialogSnackbar">
            {{ dialogSnackbarText }}

            <template v-slot:action="{ attrs }">
              <v-btn
                color="pink"
                text
                v-bind="attrs"
                v-on:click="dialogSnackbar = false"
              >
                Lukke
              </v-btn>
            </template>
          </v-snackbar>
        </div>
      </div>
    </div>
    <!-- PRODUCT SECONDARY-->
    <div v-else>
      <div v-if="changeProductDialogPage == 1">
        <div
          :class="
            !$vuetify.breakpoint.smAndDown
              ? 'pt-3 pl-7 product-change-dialog'
              : 'pt-3'
          "
        >
          <div v-if="dialogLoading" class="loading-layout">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>

          <div v-else>
            <v-row>
              <v-col
                :cols="!$vuetify.breakpoint.smAndDown ? 7 : 12"
                :class="
                  !$vuetify.breakpoint.smAndDown ? 'justify-content-center' : ''
                "
              >
                <v-row class="align-center">
                  <v-col
                    v-on:click="closeChangeProductDialog()"
                    :cols="!$vuetify.breakpoint.smAndDown ? 1 : 2"
                    :class="!$vuetify.breakpoint.smAndDown ? '' : 'mr-0 pr-0'"
                  >
                    <v-btn elevation="2" icon
                      ><v-icon>mdi-chevron-left</v-icon></v-btn
                    >
                  </v-col>
                  <v-col
                    :cols="!$vuetify.breakpoint.smAndDown ? 11 : 10"
                    :class="!$vuetify.breakpoint.smAndDown ? '' : 'ml-0 pl-0'"
                  >
                    <v-card-title>Dine tilleggsprodukter</v-card-title>
                    <v-card-subtitle class="force-align-left">{{
                      getAddressTitle(
                        changeProductDialogSelectedContract.Address || {}
                      )
                    }}</v-card-subtitle>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="pt-0 mt-2">
              <v-col
                :cols="!$vuetify.breakpoint.smAndDown ? 11 : 12"
                :class="
                  !$vuetify.breakpoint.smAndDown
                    ? 'justify-content-center pt-0 mt-0'
                    : 'pt-0 mt-0'
                "
              >
                <v-row class="align-center current-contract">
                  <v-col>
                    <v-card
                      v-for="(
                        item, key
                      ) in changeProductDialogSelectedContract.secondaryProducts"
                      :key="key"
                      class="pt-3 pl-3 pb-3 mb-5"
                    >
                      <v-row>
                        <v-col
                          :cols="!$vuetify.breakpoint.smAndDown ? 1 : 2"
                          class="mb-0 pb-0"
                        >
                          <v-avatar color="primary" size="48">
                            <v-icon class="white--text">mdi-power-plug</v-icon>
                          </v-avatar>
                        </v-col>
                        <v-col
                          :cols="!$vuetify.breakpoint.smAndDown ? 11 : 10"
                          class="pl-1 mb-0 pb-0"
                        >
                          <v-card-title class="pt-0 mt-0 pb-3 mb-0">{{
                            allSecondaryProducts.filter(
                              (secProduct) => secProduct.id == item.ProductId
                            )[0].name
                          }}</v-card-title>
                          <v-card-subtitle class="force-align-left">{{
                            allSecondaryProducts.filter(
                              (secProduct) => secProduct.id == item.ProductId
                            )[0].description
                          }}</v-card-subtitle>
                        </v-col>
                      </v-row>
                      <v-row class="pb-3 pt-0 mt-5">
                        <v-col>
                          <v-btn
                            color="primary"
                            outlined
                            rounded
                            v-on:click="
                              openChangeProductDialog(
                                2,
                                changeProductDialogSelectedContract,
                                allSecondaryProducts.filter(
                                  (secProduct) =>
                                    secProduct.id == item.ProductId
                                )[0],
                                false
                              )
                            "
                          >
                            Avslutt avtale
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                    <v-card
                      v-for="(item, key) in allSecondaryProducts.filter(
                        (product) =>
                          changeProductDialogSelectedContract.secondaryProducts.filter(
                            (secProduct) => secProduct.ProductId == product.id
                          ).length <= 0 &&
                          hasTag(product, 'minside') &&
                          product.visible === true
                      )"
                      :key="key"
                      class="pt-3 pl-3 pb-3 mb-5"
                    >
                      <v-row>
                        <v-col
                          :cols="!$vuetify.breakpoint.smAndDown ? 1 : 2"
                          class="mb-0 pb-0"
                        >
                          <v-avatar color="primary" size="48">
                            <v-icon class="white--text">mdi-power-plug</v-icon>
                          </v-avatar>
                        </v-col>
                        <v-col
                          :cols="!$vuetify.breakpoint.smAndDown ? 11 : 10"
                          class="pl-1 mb-0 pb-0"
                        >
                          <v-card-title class="pt-0 mt-0 pb-3 mb-0">{{
                            item.name
                          }}</v-card-title>
                          <v-card-subtitle class="force-align-left">{{
                            item.description
                          }}</v-card-subtitle>
                        </v-col>
                      </v-row>
                      <v-row class="pb-3 pt-0 mt-0">
                        <v-col>
                          <v-btn
                            color="primary"
                            outlined
                            rounded
                            v-on:click="
                              openChangeProductDialog(
                                3,
                                changeProductDialogSelectedContract,
                                item,
                                false
                              )
                            "
                            >Bestill</v-btn
                          >
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
          <v-snackbar v-model="dialogSnackbar">
            {{ dialogSnackbarText }}

            <template v-slot:action="{ attrs }">
              <v-btn
                color="pink"
                text
                v-bind="attrs"
                v-on:click="dialogSnackbar = false"
              >
                Lukke
              </v-btn>
            </template>
          </v-snackbar>
        </div>
      </div>
      <div v-if="changeProductDialogPage == 2">
        <div
          :class="
            !$vuetify.breakpoint.smAndDown
              ? 'pt-3 pl-7 product-change-dialog'
              : 'pt-3'
          "
        >
          <div v-if="dialogLoading" class="loading-layout">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>

          <div v-else>
            <v-row>
              <v-col
                :cols="!$vuetify.breakpoint.smAndDown ? 7 : 12"
                :class="
                  !$vuetify.breakpoint.smAndDown ? 'justify-content-center' : ''
                "
              >
                <v-row class="align-center">
                  <v-col
                    v-on:click="closeChangeProductDialog()"
                    :cols="!$vuetify.breakpoint.smAndDown ? 1 : 2"
                    :class="!$vuetify.breakpoint.smAndDown ? '' : 'mr-0 pr-0'"
                  >
                    <v-btn elevation="2" icon
                      ><v-icon>mdi-chevron-left</v-icon></v-btn
                    >
                  </v-col>
                  <v-col
                    :cols="!$vuetify.breakpoint.smAndDown ? 11 : 10"
                    :class="!$vuetify.breakpoint.smAndDown ? '' : 'ml-0 pl-0'"
                  >
                    <v-card-title
                      >Avslutt
                      {{
                        changeProductDialogSelectedProduct.name
                      }}</v-card-title
                    >
                    <v-card-subtitle class="force-align-left">{{
                      getAddressTitle(
                        changeProductDialogSelectedContract.Address || {}
                      )
                    }}</v-card-subtitle>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-alert
                  v-if="!changeProductDialogWarning"
                  text
                  dense
                  color="red accent-2"
                  border="left"
                  icon="mdi-alert-octagon"
                  class="text-left"
                >
                  Sikkert på at ønsker å avslutte avtalen?
                </v-alert>
                <v-alert
                  v-if="changeProductDialogWarning"
                  text
                  dense
                  color="red accent-2"
                  border="left"
                  icon="mdi-alert-octagon"
                  class="text-left"
                >
                  Du kan dessverre ikke avslutte denne avtalen på minside. Ta
                  kontakt med kundeservice.
                </v-alert>
              </v-col>
            </v-row>
            <v-row class="pt-0 mt-2">
              <v-col
                :cols="!$vuetify.breakpoint.smAndDown ? 11 : 12"
                :class="
                  !$vuetify.breakpoint.smAndDown
                    ? 'justify-content-center pt-0 mt-0 pb-0 mb-0'
                    : 'pt-0 mt-0 pb-0 mb-0'
                "
              >
                <v-row class="align-center current-contract mb-0 pb-0">
                  <v-col class="mb-0 pb-0">
                    <v-card class="pt-3 pl-3 pb-3">
                      <v-row class="mb-3">
                        <v-col
                          :cols="!$vuetify.breakpoint.smAndDown ? 1 : 2"
                          class="pb-0 mb-0"
                        >
                          <v-avatar color="primary" size="48">
                            <v-icon class="white--text">mdi-power-plug</v-icon>
                          </v-avatar>
                        </v-col>
                        <v-col
                          :cols="!$vuetify.breakpoint.smAndDown ? 11 : 10"
                          class="pl-1 pb-0 mb-0"
                        >
                          <v-card-title class="pt-0 mt-0 pb-3 mb-0">{{
                            changeProductDialogSelectedProduct.name
                          }}</v-card-title>
                          <v-card-subtitle class="force-align-left">{{
                            changeProductDialogSelectedProduct.description
                          }}</v-card-subtitle>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row class="mb-3">
              <v-col class="force-align-left ml-0 pl-0">
                <v-btn
                  v-if="!changeProductDialogWarning"
                  color="red accent-2"
                  class="ma-2 white--text"
                  v-on:click="setNewProductSecondary('delete')"
                >
                  AVSLUTT AVTALE
                </v-btn>
                <v-btn class="ma-2" v-on:click="closeChangeProductDialog()">
                  AVBRYT
                </v-btn>
              </v-col>
            </v-row>
          </div>
          <v-snackbar v-model="dialogSnackbar">
            {{ dialogSnackbarText }}

            <template v-slot:action="{ attrs }">
              <v-btn
                color="pink"
                text
                v-bind="attrs"
                v-on:click="dialogSnackbar = false"
              >
                Lukke
              </v-btn>
            </template>
          </v-snackbar>
        </div>
      </div>
      <div v-if="changeProductDialogPage == 3">
        <div
          :class="
            !$vuetify.breakpoint.smAndDown
              ? 'pt-3 pl-7 product-change-dialog'
              : 'pt-3'
          "
        >
          <div v-if="dialogLoading" class="loading-layout">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>

          <div v-else>
            <v-row>
              <v-col
                :cols="!$vuetify.breakpoint.smAndDown ? 7 : 12"
                :class="
                  !$vuetify.breakpoint.smAndDown ? 'justify-content-center' : ''
                "
              >
                <v-row class="align-center">
                  <v-col
                    v-on:click="closeChangeProductDialog()"
                    :cols="!$vuetify.breakpoint.smAndDown ? 1 : 2"
                    :class="!$vuetify.breakpoint.smAndDown ? '' : 'mr-0 pr-0'"
                  >
                    <v-btn elevation="2" icon
                      ><v-icon>mdi-chevron-left</v-icon></v-btn
                    >
                  </v-col>
                  <v-col
                    :cols="!$vuetify.breakpoint.smAndDown ? 11 : 10"
                    :class="!$vuetify.breakpoint.smAndDown ? '' : 'ml-0 pl-0'"
                  >
                    <v-card-title>Bekreft din bestilling</v-card-title>
                    <v-card-subtitle class="force-align-left">{{
                      getAddressTitle(
                        changeProductDialogSelectedContract.Address || {}
                      )
                    }}</v-card-subtitle>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="pt-0 mt-2">
              <v-col
                :cols="!$vuetify.breakpoint.smAndDown ? 11 : 12"
                :class="
                  !$vuetify.breakpoint.smAndDown
                    ? 'justify-content-center pt-0 mt-0'
                    : 'pt-0 mt-0'
                "
              >
                <v-row class="align-center current-contract mb-0 pb-0">
                  <v-col>
                    <v-card class="pt-3 pl-3 pb-3">
                      <v-row>
                        <v-col
                          :cols="!$vuetify.breakpoint.smAndDown ? 1 : 2"
                          class="pb-0 mb-0"
                        >
                          <v-avatar color="primary" size="48">
                            <v-icon class="white--text">mdi-power-plug</v-icon>
                          </v-avatar>
                        </v-col>
                        <v-col
                          :cols="!$vuetify.breakpoint.smAndDown ? 11 : 10"
                          class="pl-1 pb-0 mb-0"
                        >
                          <v-card-title class="pt-0 mt-0 pb-3 mb-0">{{
                            changeProductDialogSelectedProduct.name
                          }}</v-card-title>
                          <v-card-subtitle class="force-align-left">{{
                            changeProductDialogSelectedProduct.description
                          }}</v-card-subtitle>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <div class="d-flex flex-direction-row">
                            <div>
                              <v-icon color="primary"
                                >mdi-clock-time-four</v-icon
                              >
                            </div>
                            <div class="ml-3">
                              <span
                                >Avtalen blir aktivert
                                {{ getActivationDateSecondary() }}</span
                              >
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="mt-0 pt-0">
                <div class="d-flex flex-direction-row">
                  <v-checkbox
                    v-model="changeProductDialogCheck"
                    hide-details
                    class="mt-0 pt-0"
                  ></v-checkbox>
                  <template v-if="(tenantData() || {}).withdrawal_rights">
                    <span
                      :class="!$vuetify.breakpoint.smAndDown ? '' : 'text-left'"
                      >Jeg godtar
                      <a
                        :href="(tenantData() || {}).agreement_terms"
                        target="_blank"
                        >avtalevilkårene</a
                      >
                      og er kjent med
                      <a
                        :href="(tenantData() || {}).withdrawal_rights"
                        target="_blank"
                        >angreretten</a
                      ></span
                    >
                  </template>
                  <template v-else>
                    <span
                      :class="!$vuetify.breakpoint.smAndDown ? '' : 'text-left'"
                      >Jeg godtar
                      <a
                        :href="(tenantData() || {}).agreement_terms"
                        target="_blank"
                        >avtalevilkårene</a
                      ></span
                    >
                  </template>
                </div>
              </v-col>
            </v-row>
            <v-row class="mb-3">
              <v-col class="force-align-left ml-0 pl-0">
                <v-btn
                  color="primary"
                  class="ma-2 white--text"
                  v-on:click="setNewProductSecondary('add')"
                >
                  BEKREFT BESTILLINGEN
                </v-btn>
                <v-btn class="ma-2" v-on:click="closeChangeProductDialog()">
                  AVBRYT
                </v-btn>
              </v-col>
            </v-row>
          </div>
          <v-snackbar v-model="dialogSnackbar">
            {{ dialogSnackbarText }}

            <template v-slot:action="{ attrs }">
              <v-btn
                color="pink"
                text
                v-bind="attrs"
                v-on:click="dialogSnackbar = false"
              >
                Lukke
              </v-btn>
            </template>
          </v-snackbar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNorwayMonth, convertDateStr } from '../../utils/date';
import { getTenantData } from '../../utils/tenant';
import {
  changeContractProduct,
  changeContractProductSecondary,
} from '../../api/common';
import './ChangeProduct.scss';
import dayjs from 'dayjs';

export default {
  name: 'ChangeProduct',
  components: {},
  props: ['bus'],

  data() {
    return {
      now: convertDateStr(new Date().toISOString()),
      changeProductDialog: false,
      changeProductDialogPage: 0,
      changeProductDialogSelectedContract: {},
      changeProductDialogSelectedProduct: {},
      changeProductDialogSelectedPrimary: true,
      changeProductDialogWarning: false,
      changeProductDialogSelectedContractUpcommingPrimary: {},
      changeProductDialogSelectedContractUpcommingSecondary: {},
      changeProductDialogNewProduct: {},
      changeProductDialogCheck: false,
      dialogSnackbar: false,
      dialogSnackbarText: '',
      dialogLoading: false,
      allPrimaryProducts: [],
      allSecondaryProducts: [],
      screenClass: '',
      isPrimarySelection: false,
    };
  },

  created() {
    let self = this;
    this.bus.$on('ProductChanged', (data) => {
      self.changeProductDialogPage = -1;
      self.changeProductDialogSelectedContract = {};
      self.changeProductDialogSelectedProduct = {};
      self.changeProductDialogSelectedPrimary = false;
      self.changeProductDialogWarning = false;
      self.changeProductDialogSelectedContractUpcommingPrimary = {};
      self.changeProductDialogSelectedContractUpcommingSecondary = {};
      self.changeProductDialogNewProduct = {};
      self.changeProductDialogCheck = false;
      self.dialogSnackbar = false;
      self.dialogSnackbarText = '';
      self.dialogLoading = false;
      self.isPrimarySelection = false;

      self.changeProductDialogSelectedContract = data.selectedContract;
      self.changeProductDialogSelectedProduct = data.selectedProduct;
      self.changeProductDialogSelectedPrimary = data.selectedProductPrimary;
      self.allPrimaryProducts = data.primaryProductsReference;
      self.allSecondaryProducts = data.secondaryProductsReference;
      self.isPrimarySelection = self.changeProductDialogSelectedPrimary;
      self.changeProductDialogPage = data.page;
    });
  },

  computed: {
    selectedContract: {
      get() {
        return this.$store.getters['getSelectedContract'];
      },
    },
  },

  watch: {
    page: {
      deep: true,
      handler: function (newVal, oldVal) {
        console.log(oldVal + ' - ' + newVal);
        this.changeProductDialogPage = newVal;
      },
    },
    selectedContract: {
      deep: true,
      handler: function (newVal, oldVal) {
        console.log(oldVal + ' - ' + newVal);
        this.changeProductDialogSelectedContract = newVal || {};
      },
    },
    selectedProduct: {
      deep: true,
      handler: function (newVal, oldVal) {
        console.log(oldVal + ' - ' + newVal);
        this.changeProductDialogSelectedProduct = newVal || {};
      },
    },
    selectedProductPrimary: {
      deep: true,
      handler: function (newVal, oldVal) {
        console.log(oldVal + ' - ' + newVal);
        this.changeProductDialogSelectedPrimary = newVal || false;
      },
    },
    primaryProductsReference: {
      deep: true,
      handler: function (newVal, oldVal) {
        console.log(oldVal + ' - ' + newVal);
        this.allPrimaryProducts = newVal || [];
      },
    },
    secondaryProductsReference: {
      deep: true,
      handler: function (newVal, oldVal) {
        console.log(oldVal + ' - ' + newVal);
        this.allSecondaryProducts = newVal || [];
      },
    },
  },

  mounted() {
    if (localStorage.tenant == '7080010002488') {
      this.screenClass = 'klark';
    } else {
      this.screenClass = 'hks';
    }
  },

  methods: {
    tenantData() {
      return getTenantData();
    },

    hasTag(product, tag) {
      let tags = product.tags ? product.tags : product.Tags ? product.Tags : [];

      return tags.includes(tag);
    },

    getProductReference() {
      let reference;

      if (this.changeProductDialogSelectedProduct) {
        if (this.changeProductDialogSelectedPrimary) {
          reference = this.allPrimaryProducts.find(
            (item) =>
              item.id === this.changeProductDialogSelectedProduct.ProductId
          );
        } else {
          reference = this.allSecondaryProducts.find(
            (item) =>
              item.id === this.changeProductDialogSelectedProduct.ProductId
          );
        }
      }

      return reference || {};
    },

    getMonth(month) {
      return getNorwayMonth(month);
    },

    getNorwayMonth(month) {
      return getNorwayMonth(month);
    },

    getNorwayFormattedDate(date) {
      if (!date) return '';

      return (
        this.$moment(date).format('DD') +
        '.' +
        this.getNorwayMonth(this.$moment(date).month()) +
        ' ' +
        this.$moment(date).format('YYYY')
      );
    },

    getActivationDate() {
      let endDate;
      if (
        this.changeProductDialogSelectedContract &&
        this.changeProductDialogSelectedContract.EndDate
      ) {
        endDate = this.changeProductDialogSelectedContract.EndDate;
      } else {
        endDate = this.$moment(this.now).add(1, 'days');
      }

      return this.getNorwayFormattedDate(endDate);
    },

    getActivationDateSecondary() {
      return this.getNorwayFormattedDate(this.$moment(this.now));
    },

    openChangeProductDialog(
      page,
      selectedContract,
      selectedProduct,
      selectedProductPrimary
    ) {
      this.changeProductDialog = true;

      if (this.isPrimarySelection) {
        if (page <= 0) {
          this.changeProductDialogSelectedContract = selectedContract;
          this.changeProductDialogSelectedProduct = selectedProduct;
          this.changeProductDialogSelectedPrimary = selectedProductPrimary;
          this.changeProductDialogSelectedContractUpcommingPrimary = {};
          this.changeProductDialogSelectedContractUpcommingSecondary = {};
          this.changeProductDialogWarning = false;
          this.changeProductDialogNewProduct = {};
          this.changeProductDialogCheck = false;

          if (
            this.changeProductDialogSelectedContract.UpcomingProductChange &&
            this.changeProductDialogSelectedContract.UpcomingProductChange
              .Products
          ) {
            let upcommingPrimary =
              this.changeProductDialogSelectedContract.UpcomingProductChange.Products.find(
                (item) => {
                  return item.PrimaryProduct === true;
                }
              );

            if (upcommingPrimary) {
              this.changeProductDialogSelectedContractUpcommingPrimary =
                upcommingPrimary;
            }

            let upcommingSecondary =
              this.changeProductDialogSelectedContract.Products.find((item) => {
                return item.PrimaryProduct === false;
              });

            if (upcommingSecondary) {
              this.changeProductDialogSelectedContractUpcommingSecondary =
                upcommingSecondary;
            }
          }

          this.changeProductDialogPage = page;
        } else if (page == 1) {
          if (this.changeProductDialogSelectedProduct) {
            let tmp;

            if (this.changeProductDialogSelectedProduct.PrimaryProduct) {
              tmp = this.allPrimaryProducts.filter(
                (product) =>
                  product.id ==
                  this.changeProductDialogSelectedProduct.ProductId
              )[0];
            } else {
              tmp = this.allSecondaryProducts.filter(
                (product) =>
                  product.id ==
                  this.changeProductDialogSelectedProduct.ProductId
              )[0];
            }

            let tags =
              tmp && tmp.Tags ? tmp.Tags : tmp && tmp.tags ? tmp.tags : [];

            let found = false;
            tags.forEach((tag) => {
              if ((tag || '').toLowerCase() == 'gebyr') found = true;
            });

            this.changeProductDialogWarning = found;

            if (!this.changeProductDialogWarning) {
              this.changeProductDialogPage = page;
            }
          }
        } else if (page == 2) {
          this.changeProductDialogNewProduct = selectedContract;
          this.changeProductDialogPage = page;
        }
      } else {
        this.changeProductDialogSelectedContract = selectedContract;
        this.changeProductDialogSelectedProduct = selectedProduct;
        this.changeProductDialogSelectedPrimary = selectedProductPrimary;
        this.changeProductDialogSelectedContractUpcommingPrimary = {};
        this.changeProductDialogSelectedContractUpcommingSecondary = {};
        this.changeProductDialogWarning = false;
        this.changeProductDialogNewProduct = {};
        this.changeProductDialogCheck = false;

        this.changeProductDialogPage = page;
        let newTmp = this.changeProductDialogSelectedProduct;
        let newTags =
          newTmp && newTmp.Tags
            ? newTmp.Tags
            : newTmp && newTmp.tags
            ? newTmp.tags
            : [];
        let secondaryFound = false;
        newTags.forEach((tag) => {
          if ((tag || '').toLowerCase() == 'gebyr') secondaryFound = true;
        });
        this.changeProductDialogWarning = secondaryFound;
        if (!this.changeProductDialogWarning) {
          this.changeProductDialogPage = page;
        }
      }
    },

    closeChangeProductDialog(refresh) {
      this.changeProductDialogSelectedContract = {};
      this.changeProductDialogSelectedProduct = {};
      this.changeProductDialogNewProduct = {};
      this.changeProductDialogCheck = false;
      this.changeProductDialogSelectedPrimary = true;
      this.changeProductDialogSelectedContractUpcommingPrimary = {};
      this.changeProductDialogSelectedContractUpcommingSecondary = {};
      this.changeProductDialogWarning = false;
      this.changeProductDialog = false;
      this.changeProductDialogPage = 0;
      this.dialogSnackbar = false;
      this.dialogSnackbarText = '';
      this.dialogLoading = false;
      this.allPrimaryProducts = [];
      this.allSecondaryProducts = [];
      this.isPrimarySelection = false;

      this.$emit('ChangeProductClose', { refresh: refresh });
    },

    getAddressTitle(address) {
      let firstPart = (
        (address.StreetName || '') +
        ' ' +
        (address.BuildingNumber || '')
      ).trim();
      let secondPart = (
        (address.PostalCode || '') +
        ' ' +
        (address.City || '')
      ).trim();
      let decoratedAddress =
        firstPart + (firstPart && secondPart ? ',' : '') + secondPart;

      return decoratedAddress;
    },

    uuidv4() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
            v = c == 'x' ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    },

    async setNewProduct() {
      if (!this.changeProductDialogCheck) {
        this.dialogSnackbar = true;
        this.dialogSnackbarText = 'Bekreft vilkårene';

        return;
      }

      let productsToChange = [...this.selectedContract.Products];

      let oldProduct = productsToChange.find(
          (item) =>
            item.ProductId === this.changeProductDialogSelectedProduct.ProductId
        ),
        product = '';

      if (this.changeProductDialogSelectedPrimary) {
        product = this.allPrimaryProducts.find(
          (item) => item.id === this.changeProductDialogNewProduct.id
        );
      } else {
        product = this.allSecondaryProducts.find(
          (item) => item.id === this.changeProductDialogNewProduct.id
        );
      }

      if (!product) {
        this.dialogSnackbar = true;
        this.dialogSnackbarText = 'Produktet ble ikke funnet';

        return;
      }

      oldProduct.ProductName = product.name;
      oldProduct.ProductId = product.id;
      oldProduct.PrimaryProduct = product.primaryProduct;
      oldProduct.StartDate = dayjs().startOf('day').toISOString();
      oldProduct.EndDate = null;

      console.log(productsToChange);
      productsToChange.forEach((prod) => {
        if (prod.PrimaryProduct) {
          delete prod.StartDate;
        }
      });

      let data = {
        AccountingPoint: {
          Identification: this.selectedContract.AccountingPointIdentification,
          Guid: this.selectedContract.AccountingPointGuid,
        },
        Account: {
          Guid: this.selectedContract.AccountGuid,
        },
        RequestedChannel: 'Mypage',
        RequestId: this.uuidv4(),
        Products: productsToChange,
        StartDate: dayjs().startOf('day').add(1, 'day').toISOString(),
      };

      console.log(data, this.guid);

      this.dialogLoading = true;

      try {
        let res = await changeContractProduct(this.guid, data);
        console.log(res);
        this.dialogLoading = false;
        this.closeChangeProductDialog(true);
      } catch (e) {
        console.log(e);
        this.dialogLoading = false;
        this.dialogSnackbar = true;
        this.dialogSnackbarText = 'Error';
      }

      /*return new Promise((resolve, reject) => {
                changeContractProduct(this.guid, data).then((res) => {
                    console.log(res);


                    let self = this;
                    setTimeout(function(){
                        self.getContracts();
                    }, 500)
                }).catch(error => {
                    console.log(error);

                    reject(error);
                });
            });*/
    },

    async setNewProductSecondary(action) {
      let data;

      switch (action) {
        case 'delete':
          data = {
            RequestId: this.uuidv4(),
            Commands: [
              {
                CommandName: 'RemoveProduct',
                CommandData: {
                  EndDate: this.now,
                  ProductId: this.changeProductDialogSelectedProduct.id,
                },
              },
            ],
          };
          break;
        case 'add':
          if (!this.changeProductDialogCheck) {
            this.dialogSnackbar = true;
            this.dialogSnackbarText = 'Bekreft vilkårene';

            return;
          }

          data = {
            RequestId: this.uuidv4(),
            Commands: [
              {
                CommandName: 'AddProduct',
                CommandData: {
                  StartDate: this.now,
                  ProductId: this.changeProductDialogSelectedProduct.id,
                  ProductName: this.changeProductDialogSelectedProduct.name,
                },
              },
            ],
          };
          break;
      }

      this.dialogLoading = true;

      try {
        let res = await changeContractProductSecondary(
          this.changeProductDialogSelectedContract.ContractGuid,
          data
        );
        console.log(res);
        this.dialogLoading = false;
        this.closeChangeProductDialog(true);
      } catch (e) {
        console.log(e);
        this.dialogLoading = false;
        this.dialogSnackbar = true;
        this.dialogSnackbarText = 'Error';
      }
    },
  },
};
</script>
